(function ($) {
	class W4D_Meter {
		constructor() {
			this.initSelectors();
			if (!this.$meterContainer.length) return;
			this.isFirefox = /Firefox/.test(navigator.userAgent);
			// Fill from empty on page load.
			this.updateMeterAfterCartChange(this.$meterContainer.data('shipping-progress'), 0);
			this.bindEvents();
		}

		initSelectors() {
			this.$meterContainer = $('[data-js-meter-container]');
			this.$meterElement = this.$meterContainer.find('[data-js-meter-element]');
			this.$meterText = this.$meterContainer.find('[data-js-meter-text]');
			// The server renders the delivery icon in front of the text; keep it when the text is replaced.
			this.iconHtml ??= this.$meterText.children('i').first().prop('outerHTML') || '';
		}

		bindEvents() {
			let resizeTimeout;
			$(window).on('resize', () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => {
					this.updateTextPosition();
				}, 150);
			});
		}

		applyFirefoxTransform() {
			if (!this.isFirefox) return;

			// Only the inline variant 1 label tracks the bar's end; every other layout keeps its CSS position.
			if (
				!this.$meterContainer.hasClass('meter--1') ||
				this.$meterContainer.hasClass('meter--completed') ||
				this.$meterContainer.hasClass('meter--text-centered') ||
				this.$meterContainer.hasClass('meter--text-stacked')
			) {
				this.$meterText.css('transform', '');
				return;
			}

			const meterElement = this.$meterElement[0];
			const meterWidth = meterElement.offsetWidth;
			const progressWidth = (parseFloat(meterElement.value) / parseFloat(meterElement.max)) * meterWidth;

			// On initial load (when text-inside is NOT present)
			if (!this.$meterContainer.hasClass('text-inside')) {
				const transform = `translateX(calc(-${meterWidth}px + ${progressWidth}px))`;
				this.$meterText.css('transform', transform);
			} else {
				// When text-inside class is present
				const textWidth = this.$meterText.outerWidth();
				const transform = `translateX(calc(-${meterWidth}px + ${progressWidth}px - ${textWidth}px))`;
				this.$meterText.css('transform', transform);
			}
		}

		updateTextPosition() {
			if (this.$meterContainer.prop('hidden')) return;
			// Measure the unwrapped label before choosing a position, including after a resize.
			this.$meterContainer.removeClass('meter--text-centered meter--text-stacked');
			const textWidth = this.$meterText.outerWidth();
			const containerWidth = this.$meterContainer.width();
			if (textWidth > containerWidth) {
				this.$meterContainer.removeClass('text-inside').addClass('meter--text-stacked');
				this.$meterText.css('transform', '');
				return;
			}
			if (!this.$meterContainer.hasClass('meter--1')) return;
			const meterElement = this.$meterElement[0];
			const progressWidth = (Number(meterElement.value) / Number(meterElement.max)) * meterElement.offsetWidth;
			const remainingWidth = containerWidth - progressWidth;
			const buffer = 20;
			const fitsOutside = textWidth + buffer <= remainingWidth;
			const fitsInside = textWidth + buffer <= progressWidth;
			this.$meterContainer.toggleClass('text-inside', !fitsOutside && fitsInside);
			// When neither segment fits, the full-width label still stays within the bar.
			this.$meterContainer.toggleClass('meter--text-centered', !fitsOutside && !fitsInside);
			this.applyFirefoxTransform();
		}

		updateMeterAfterCartChange(progress, startValue) {
			// Old plugin responses contain only a gross total, which cannot determine eligibility.
			if (!progress || typeof progress !== 'object') return;
			this.initSelectors();
			if (!this.$meterContainer.length) return;
			if (this.animationFrame) cancelAnimationFrame(this.animationFrame);

			const visible = progress.state === 'progress' || progress.state === 'achieved';
			const achieved = progress.state === 'achieved';
			const target = !achieved && Number(progress.target) > 0 ? Number(progress.target) : 1;
			const current = achieved ? 1 : Math.min(target, Math.max(0, Number(progress.current) || 0));
			// A completed bar is full at max 1; continue from a full bar instead of 1/target.
			const oldValue =
				startValue ??
				(this.$meterContainer.hasClass('meter--completed') ? target : Math.min(target, Number(this.$meterElement.val()) || 0));
			this.$meterContainer
				.prop('hidden', !visible)
				.toggle(visible)
				.toggleClass('meter--completed', achieved)
				.attr('data-state', progress.state)
				.attr('data-source', progress.source || '')
				.attr('data-current-price', progress.current)
				.attr('data-free-delivery', progress.target)
				.data('shipping-progress', progress);
			this.$meterText.html(this.iconHtml + (progress.text_html || ''));
			this.$meterElement.attr('max', target);
			if (!visible) {
				this.$meterElement.val(0);
				return;
			}
			this.animateMeterValue(oldValue, current);
		}

		animateMeterValue(startValue, endValue, duration = 300) {
			if (this.animationFrame) {
				cancelAnimationFrame(this.animationFrame);
			}

			// Choose the label position once, for the final value, before the bar moves. The label then follows
			// the bar through its CSS anchor; only Firefox needs a per-frame transform.
			this.$meterElement.val(endValue);
			this.updateTextPosition();
			this.$meterElement.val(startValue);

			const startTime = performance.now();
			const updateMeter = (currentTime) => {
				const elapsedTime = currentTime - startTime;
				const progress = Math.min(elapsedTime / duration, 1);
				const easeProgress = 1 - (1 - progress) * (1 - progress);
				const currentValue = startValue + (endValue - startValue) * easeProgress;

				this.$meterElement.val(currentValue);
				this.applyFirefoxTransform();
				if (progress < 1) this.animationFrame = requestAnimationFrame(updateMeter);
			};
			this.animationFrame = requestAnimationFrame(updateMeter);
		}
	}

	$(document).ready(() => {
		window.W4D_Meter = new W4D_Meter();
	});
})(jQuery);
